(() => {
  // Only public product/feature signals. Never include search terms, email,
  // recipient names, tracking IDs, precise locations, or arbitrary query strings.
  const allowed = new Set(['product_selected', 'product_viewed', 'pack_selected', 'add_to_cart_intent', 'demo_history', 'demo_alerts', 'demo_sharing', 'demo_item_selected', 'demo_alert_saved', 'demo_product_intent', 'demo_share_preview', 'demo_shared_product_intent', 'guide_selected', 'about_label_selected', 'about_features_selected', 'about_contact_selected', 'how_it_works_product_intent', 'hubble_product_intent']);
  const products = new Set(['single', 'pack', 'shipzik-tracking-label', 'shipzik-tracking-3-pack']);
  const previewViews = new Set(['single', 'pack', 'features', 'shipment-tracking', 'equipment-tracking', 'how-it-works', 'hubble-network-tracking', 'about-tracking', 'guides']);
  const emit = (event, product = null) => {
    if (!allowed.has(event)) return;
    const url = new URL(location.href);
    const view = url.searchParams.get('view');
    const detail = { event, product: products.has(product) ? product : null, path: url.pathname + (previewViews.has(view) ? '?view=' + view : '') };
    document.dispatchEvent(new CustomEvent('shipzik:storefront', { detail }));
    // Preview QA never enters live reporting. Shopify manages pixel consent;
    // require its analytics permission here too, and fail closed if unavailable.
    if (document.body.dataset.storefrontPreview !== 'false') return;
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() !== true) return;
      const result = window.Shopify?.analytics?.publish?.('shipzik:' + event, detail);
      Promise.resolve(result).catch(() => {});
    } catch { /* Analytics must never interrupt buying or exploration. */ }
  };
  window.ShipzikEvents = { emit };
})();
